import { AxiosRequestConfig } from "axios";
import {getAxiosInstance, requestConfig} from "../../http-common";

const RESOURCE_NAME = "clustering";

const getAllRules = (entityId: number) => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/getallrules?entityId=${entityId}`, requestConfig());
};

const getAllRuleDefinitions = (ruleId: number) => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/getallruledefinitions?ruleId=${ruleId}`, requestConfig());
};

const getTransforms = () => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/gettransforms?`, requestConfig());
};

const createRule = (model: any) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/createRule`, model, requestConfig());
};

const createRuleDefinition = (model: any) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/createRuleDefinition`, model, requestConfig());
};

const updateRule = (model: any) => {
  const http = getAxiosInstance();
  return http.put(`${RESOURCE_NAME}/updateRule/${model.id}`, model, requestConfig());
};

const updateRuleDefinition = (fieldId: number, model: any) => {
  const http = getAxiosInstance();
  return http.put(`${RESOURCE_NAME}/updateRuleDefinition/${model.ruleId}/${fieldId}`, model, requestConfig());
};

const deleteRule = (id: number) => {
  const http = getAxiosInstance();
  return http.delete(`${RESOURCE_NAME}/deleteRule/${id}`, requestConfig());
};

const deleteRuleDefinition = (ruleId: number, fieldId: number) => {
  const http = getAxiosInstance();
  return http.delete(`${RESOURCE_NAME}/deleteRuleDefinition/${ruleId}/${fieldId}`, requestConfig());
};

const getClusteringResults = (groupCode: string, entity: string, batchId?: string) => {  
  const http = getAxiosInstance();
  
  let url = `${RESOURCE_NAME}/getClusteringResults?groupCode=${groupCode}&entity=${entity}`;
  if (batchId) {
    url += `&batchId=${batchId}`;
  }

  return http.get(url, requestConfig());
}

const downloadClusteringResults = (groupCode: string, entity: string, batchId?: string, rowCount?: number) => {
  const http = getAxiosInstance();
  
  let url = `${RESOURCE_NAME}/getClusteringResultsDownload?groupCode=${groupCode}&entity=${entity}`;

  if (batchId) {
    url += `&batchId=${batchId}`;
  }

  if(rowCount) {
    url += `&rowCount=${rowCount}`;
  }

  var config: AxiosRequestConfig = requestConfig();
  config.responseType = 'blob';

  return http.get(url, config);
}

const ClusteringService = {
  getAllRules,
  getAllRuleDefinitions,
  getTransforms,
  createRule,
  createRuleDefinition,
  updateRule,
  updateRuleDefinition,
  deleteRule,
  deleteRuleDefinition,
  getClusteringResults,
  downloadClusteringResults,
};

export default ClusteringService;
